export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-amber-600 to-amber-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Hemen İletişime Geçin
          </h2>
          <p className="text-xl text-amber-100 max-w-3xl mx-auto">
            Hayalinizdeki mobilyalar için bize ulaşın. Uzman ekibimiz size en iyi çözümü sunmak için hazır.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-colors duration-300">
            <div className="bg-white text-amber-700 w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
              <i className="ri-map-pin-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Adres</h3>
            <p className="text-amber-100 text-base leading-relaxed">
              Hacıbey Mahallesi<br />
              Yeni Sanayi Çarşısı<br />
              Endüstri Cad No: 20<br />
              Nallıhan/ANKARA
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-colors duration-300">
            <div className="bg-white text-amber-700 w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
              <i className="ri-whatsapp-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">WhatsApp</h3>
            <a
              href="https://wa.me/905303030218"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-100 hover:text-white transition-colors duration-200 text-lg cursor-pointer"
            >
              +90 530 303 02 18
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-colors duration-300">
            <div className="bg-white text-amber-700 w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
              <i className="ri-phone-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Telefon</h3>
            <a
              href="tel:+905303030218"
              className="text-amber-100 hover:text-white transition-colors duration-200 text-lg cursor-pointer"
            >
              +90 530 303 02 18
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-colors duration-300">
            <div className="bg-white text-amber-700 w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
              <i className="ri-time-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Çalışma Saatleri</h3>
            <p className="text-amber-100 text-lg">
              Pazartesi - Cumartesi<br />
              09:00 - 18:00
            </p>
          </div>
        </div>

        <div className="text-center">
          <a
            href="https://wa.me/905303030218"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-amber-700 px-10 py-5 rounded-lg hover:bg-gray-100 transition-colors duration-200 font-bold text-xl shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-3xl"></i>
            WhatsApp ile Hemen Teklif Alın
          </a>
        </div>
      </div>
    </section>
  );
}
